var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"mt-1 cursor-pointer",class:_vm.hoverClass,attrs:{"to":{ name: 'document_request', params: { request: _vm.link } },"active-class":_vm.activeClass,"tag":"div"}},[_c('small',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }